import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Settings, Users, ArrowLeft, MessageSquare, Image, Star, Mail, UsersRound, Sparkles, Activity } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import ThemeToggle from "@/components/ThemeToggle";
import NotificationsBell from "@/components/admin/NotificationsBell";

const ITEMS = [
    { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
    { to: "/admin/products", label: "Products", icon: Package, testId: "admin-nav-products" },
    { to: "/admin/orders", label: "Orders", icon: ShoppingBag, testId: "admin-nav-orders" },
    { to: "/admin/reviews", label: "Reviews", icon: Star, testId: "admin-nav-reviews" },
    { to: "/admin/gallery", label: "Gallery", icon: Image, testId: "admin-nav-gallery" },
    { to: "/admin/leads", label: "Leads", icon: Users, testId: "admin-nav-leads" },
    { to: "/admin/email", label: "Email", icon: Mail, testId: "admin-nav-email" },
    { to: "/admin/team", label: "Team", icon: UsersRound, testId: "admin-nav-team" },
    { to: "/admin/miniatures", label: "Miniatures", icon: Sparkles, testId: "admin-nav-miniatures" },
    { to: "/admin/miniature-activity", label: "Mini Activity", icon: Activity, testId: "admin-nav-miniature-activity" },
    { to: "/admin/settings", label: "Settings", icon: Settings, testId: "admin-nav-settings" },
];

const AdminLayout = () => {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen flex" data-testid="admin-layout">
            <aside className="w-60 shrink-0 bg-primary text-primary-foreground p-4 flex flex-col sticky top-0 h-screen">
                <Link to="/" className="flex items-center gap-2 mb-6">
                    <div className="w-9 h-9 rounded-full overflow-hidden ring-2 ring-brand-gold/60 bg-white">
                        <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_custom-collectibles-2/artifacts/vm51spgg_Screenshot%202026-07-23%20at%206.35.36%E2%80%AFAM.png" alt="Cherishables" className="w-full h-full object-cover" />
                    </div>
                    <span className="font-display text-lg font-bold">Cherishables</span>
                </Link>
                <nav className="space-y-1 flex-1">
                    {ITEMS.map((i) => (
                        <NavLink key={i.to} to={i.to} end={i.end} data-testid={i.testId}
                            className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-xl text-sm ${isActive ? "bg-white/15 font-semibold" : "hover:bg-white/10 text-white/80"}`}>
                            <i.icon className="w-4 h-4" /> {i.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="border-t border-white/15 pt-3 space-y-1">
                    <div className="px-3 py-1 text-xs text-white/60">Signed in as</div>
                    <div className="px-3 text-sm font-semibold truncate">{user?.email}</div>
                    <button onClick={logout} className="w-full text-left px-3 py-2 rounded-xl text-sm text-white/80 hover:bg-white/10">Log out</button>
                    <Link to="/" className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm text-white/80 hover:bg-white/10"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
                </div>
            </aside>
            <main className="flex-1 min-w-0 relative">
                <div className="absolute top-4 right-6 z-10 flex items-center gap-2">
                    <NotificationsBell />
                    <ThemeToggle />
                </div>
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
